import { omit } from "lodash";
import { HTMLAttributes, ReactNode, forwardRef } from "react";
import clsx from "clsx";
import { cn } from "@/core/helpers/cn";

type Props = {
  children?: ReactNode;
  color: string;
} & HTMLAttributes<HTMLDivElement>;

const InventoryBorderBox = forwardRef<HTMLDivElement, Props>(
  ({ children, className, color, ...rest }, ref) => {
    const restStyle = rest.style;
    const omitRest = omit(rest, ["style"]);
    return (
      <div
        ref={ref}
        className={cn("relative rounded-[inherit]", className)}
        style={{
          backgroundImage: `linear-gradient(to top, ${color}20, transparent 80%)`,
          ...restStyle,
        }}
        {...omitRest}
      >
        {children}
        <div
          className={clsx("absolute inset-0 rounded-[inherit]")}
          style={{
            padding: "2px",
            background: `linear-gradient(90deg, transparent, ${color}40 25%, ${color} 50%, ${color}40 75%, transparent)`,
            WebkitMask: `
            linear-gradient(#fff 0 0) content-box, 
            linear-gradient(#fff 0 0)
          `,
            WebkitMaskComposite: "xor",
            maskComposite: "exclude",
            clipPath: "inset(calc(100% - 4px) 0 0 0)",
            zIndex: 0,
          }}
        />
      </div>
    );
  },
);

InventoryBorderBox.displayName = "InventoryBorderBox";

export default InventoryBorderBox;
